module.exports = __webpack_public_path__ + "static/media/icetcsdp.aff2c0b0.jpg";